import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { FormInputs } from 'context/FormProvider'
import { getAccountType } from 'utils'
import { consoleLog } from 'utils/simpleLogger'
import { useRiseUpAPIV1 } from './useRiseUpAPIV1'

export const useNorthCapitalApi = () => {
  const RISE_UP_API_V1 = process.env.REACT_APP_RISE_UP_API_V1
  const OFFERING_ID = process.env.REACT_APP_OFFERING_ID
  const { getIPAddress } = useRiseUpAPIV1()

  const onboardIndividual = async (data: FormInputs, bearer_token: string) => {
    const partyData = {
      domicile: 'U.S. citizen',
      firstName: data.basicInfo.firstName,
      middleInitial: data.basicInfo.middleName,
      lastName: data.basicInfo.lastName,
      socialSecurityNumber: data.financialInfo.ssn,
      dob: data.personalInfo.birthday,
      primCountry: data.addressInfo.country,
      primAddress1: data.addressInfo.Street1,
      primAddress2: data.addressInfo.Street2,
      primCity: data.addressInfo.city,
      primState: data.addressInfo.state,
      primZip: data.addressInfo.postalCode,
      emailAddress: data.email,
      emailAddress2: data.email,
      phone: data.personalInfo.phoneNumber,
      phone2: data.personalInfo.phoneNumber,
      invest_to: '0',
    }

    const accountData = {
      accountRegistration: data.basicInfo.firstName + ' ' + data.basicInfo.middleName + ' ' + data.basicInfo.lastName,
      type: getAccountType(data.investingProfile.option),
      // entityType: 'Revocable Trust',
      domesticYN: 'domestic_account',
      streetAddress1: data.addressInfo.Street1,
      streetAddress2: data.addressInfo.Street2,
      city: data.addressInfo.city,
      state: data.addressInfo.state,
      zip: data.addressInfo.postalCode,
      country: data.addressInfo.country,
      phone: data.personalInfo.phoneNumber,
      KYCstatus: 'Pending',
      AMLstatus: 'Pending',
      AccreditedStatus: 'Pending',
    }

    const linkData = {
      firstEntryType: 'Account',
      relatedEntryType: 'IndivACParty',
      primary_value: '1',
      linkType: 'member',
      notes: 'Notes',
    }

    const request: AxiosRequestConfig = {
      method: 'post',
      url: `${RISE_UP_API_V1}/north-capital/onboard-individual`,
      data: {
        partyData,
        accountData,
        linkData,
      },
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${bearer_token}`,
      },
    }

    let res: AxiosResponse
    res = await axios(request)
    return res
  }

  const onboardJoint = async (data: FormInputs, bearer_token: string) => {
    const primary = {
      partyData: {
        domicile: 'U.S. citizen',
        firstName: data.basicInfo.firstName,
        middleInitial: data.basicInfo.middleName,
        lastName: data.basicInfo.lastName,
        socialSecurityNumber: data.financialInfo.ssn,
        dob: data.personalInfo.birthday,
        primCountry: data.addressInfo.country,
        primAddress1: data.addressInfo.Street1,
        primAddress2: data.addressInfo.Street2,
        primCity: data.addressInfo.city,
        primState: data.addressInfo.state,
        primZip: data.addressInfo.postalCode,
        emailAddress: data.email,
        emailAddress2: data.email,
        phone: data.personalInfo.phoneNumber,
        phone2: data.personalInfo.phoneNumber,
        invest_to: '0',
      },
      accountData: {
        accountRegistration: data.basicInfo.firstName + ' ' + data.basicInfo.middleName + ' ' + data.basicInfo.lastName,
        type: getAccountType(data.investingProfile.option),
        domesticYN: 'domestic_account',
        streetAddress1: data.addressInfo.Street1,
        streetAddress2: data.addressInfo.Street2,
        city: data.addressInfo.city,
        state: data.addressInfo.state,
        zip: data.addressInfo.postalCode,
        country: data.addressInfo.country,
        phone: data.personalInfo.phoneNumber,
        KYCstatus: 'Pending',
        AMLstatus: 'Pending',
        AccreditedStatus: 'Pending',
      },
      linkData: {
        firstEntryType: 'Account',
        relatedEntryType: 'IndivACParty',
        primary_value: '1',
        linkType: 'member',
        notes: 'Notes',
      },
    }

    const secondary = {
      partyData: {
        domicile: 'U.S. citizen',
        firstName: data.secondary?.basicInfo.firstName,
        middleInitial: data.secondary?.basicInfo.middleName,
        lastName: data.secondary?.basicInfo.lastName,
        socialSecurityNumber: data.secondary?.financialInfo.ssn,
        dob: data.secondary?.personalInfo.birthday,
        primCountry: data.secondary?.addressInfo.country,
        primAddress1: data.secondary?.addressInfo.Street1,
        primAddress2: data.secondary?.addressInfo.Street2,
        primCity: data.secondary?.addressInfo.city,
        primState: data.secondary?.addressInfo.state,
        primZip: data.secondary?.addressInfo.postalCode,
        emailAddress: data.secondary?.email,
        emailAddress2: data.secondary?.email,
        phone: data.secondary?.personalInfo.phoneNumber,
        phone2: data.secondary?.personalInfo.phoneNumber,
        invest_to: '0',
      },
      accountData: {
        accountRegistration:
          data.secondary?.basicInfo.firstName +
          ' ' +
          data.secondary?.basicInfo.middleName +
          ' ' +
          data.secondary?.basicInfo.lastName,
        type: getAccountType(data.investingProfile.option),
        domesticYN: 'domestic_account',
        streetAddress1: data.secondary?.addressInfo.Street1,
        streetAddress2: data.secondary?.addressInfo.Street2,
        city: data.secondary?.addressInfo.city,
        state: data.secondary?.addressInfo.state,
        zip: data.secondary?.addressInfo.postalCode,
        country: data.secondary?.addressInfo.country,
        phone: data.secondary?.personalInfo.phoneNumber,
        KYCstatus: 'Pending',
        AMLstatus: 'Pending',
        AccreditedStatus: 'Pending',
      },
      linkData: {
        firstEntryType: 'Account',
        relatedEntryType: 'IndivACParty',
        primary_value: '0',
        linkType: 'member',
        notes: 'Notes',
      },
    }

    const request: AxiosRequestConfig = {
      method: 'post',
      url: `${RISE_UP_API_V1}/north-capital/onboard-joint`,
      data: {
        primary,
        secondary,
      },
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${bearer_token}`,
      },
    }

    let res: AxiosResponse
    res = await axios(request)
    return res
  }

  /** TODO Populate data for entity
   * export interface EntityInterface {
  clientID: string;
  developerAPIKey: string;
  domicile?: 'U.S. citizen' | 'U.S. resident' | 'non-resident'; // conditional type
  entityName: string;
  entityType?: 'Revocable Trust' | 'Irrevocable Trust' | 'Limited Partnership' | 'LLC' | 'Corporation'; // integer type in the documentation but given as string in the example
  entityDesc?: string;
  ein?: string;
  primCountry: string;
  primAddress1: string;
  primAddress2?: string;
  primCity: string;
  primState: string; // Optional for non-U.S. entities
  primZip: string;
  emailAddress: string;
  emailAddress2?: string;
  phone?: number;
  phone2?: number;
  totalAssets?: number;
  ownersAI?: 'Yes' | 'No'; // conditional type
  KYCstatus?: 'Pending' | 'Auto Approved' | 'Manually Approved' | 'Disapproved'; // conditional type
  AMLstatus?: 'Pending' | 'Auto Approved' | 'Manually Approved' | 'Disapproved'; // conditional type
  AMLdate?: string;
  tags?: string;
  createdIpAddress: string;
  notes?: string;
  formationDate?: string; // given as date type in the documentation but string in the example
}
   */

  const onboardEntity = async (data: FormInputs, bearer_token: string) => {
    let finalEntityData
    const partyData = {
      domicile: 'U.S. citizen',
      firstName: data.basicInfo.firstName,
      middleInitial: data.basicInfo.middleName,
      lastName: data.basicInfo.lastName,
      socialSecurityNumber: data.financialInfo.ssn,
      dob: data.personalInfo.birthday,
      primCountry: data.addressInfo.country,
      primAddress1: data.addressInfo.Street1,
      primAddress2: data.addressInfo.Street2,
      primCity: data.addressInfo.city,
      primState: data.addressInfo.state,
      primZip: data.addressInfo.postalCode,
      emailAddress: data.email,
      emailAddress2: data.email,
      phone: data.personalInfo.phoneNumber,
      phone2: data.personalInfo.phoneNumber,
      createdIpAddress: data.ipAddress,
      occupation: '',
      associatedPerson: 'Yes',
      invest_to: '1',
      empStatus: '',
      empCountry: '',
      empName: '',
      empAddress1: '',
      empAddress2: '',
      empCity: '',
      empState: '',
      empZip: '',
      currentAnnIncome: '',
      avgAnnIncome: '',
      currentHouseholdIncome: '',
      avgHouseholdIncome: '',
      householdNetworth: '',
      KYCstatus: '',
      AMLstatus: '',
      AMLdate: '',
      tags: '',
      field1: '',
      field2: '',
      field3: '',
      notes: '',
    }
    const linkData = {
      firstEntryType: 'Account',
      relatedEntryType: 'EntityACParty',
      primary_value: '1',
      linkType: 'member',
      notes: 'Notes',
    }

    switch (data.investingProfile?.option) {
      case 'IN_BEHALF_OF_AN_ENTITY':
        finalEntityData = {
          entityData: {
            entityName: data.entityDetails?.companyName,
            entityType:
              data.entityDetails?.type === 'Other' ? data.entityDetails?.legalStructure : data.entityDetails?.type,
            ein: data.entityDetails?.ein,
            domicile: 'U.S. Citizen',
            primCountry: data.entityDetails?.addressInfo?.country,
            primAddress1: data.entityDetails?.addressInfo?.Street1,
            primAddress2: data.entityDetails?.addressInfo?.Street2 || '',
            primCity: data.entityDetails?.addressInfo?.city,
            primState: data.entityDetails?.addressInfo?.state,
            primZip: data.entityDetails?.addressInfo?.postalCode,
            emailAddress: data.entityDetails?.email,
            phone: parseInt(data.entityDetails?.phoneNumber || ''),
            ownersAI: data.investingProfile.accreditedInvestor === 'yes' ? 'Yes' : 'No',
            createdIpAddress: data.ipAddress,
            KYCstatus: 'Pending',
            AMLstatus: 'Pending',
            AMLdate: '',
            tags: '',
            notes: '',
            formationDate: '',
            entityDesc: 'Company',
            emailAddress2: data.entityDetails?.email,
            phone2: parseInt(data.entityDetails?.phoneNumber || ''),
            totalAssets: 0,
          },
          partyData,
          accountData: {
            emailAddress: data.entityDetails?.email,
            accountRegistration: data.entityDetails?.companyName,
            type: 'Entity',
            domesticYN: 'domestic account',
            streetAddress1: data.entityDetails?.addressInfo?.Street1,
            streetAddress2: data.entityDetails?.addressInfo?.Street2 || '',
            city: data.entityDetails?.addressInfo?.city,
            state: data.entityDetails?.addressInfo?.state,
            zip: data.entityDetails?.addressInfo?.postalCode,
            country: 'USA',
            phone: parseInt(data.entityDetails?.phoneNumber || ''),
            taxID: '',
            KYCstatus: 'pending',
            AMLstatus: 'pending',
            suitabilityScore: '',
            suitabilityDate: '',
            suitabilityApprover: '',
            AccreditedStatus: 'pending',
            AIlow: 'income',
            AIdate: '',
            '506cLimit': '',
            accountTotalLimit: '',
            singleInvestmentLimit: '',
            associatedAC: 'yes',
            syndicate: 'no',
            tags: '',
            notes: '',
            approvalStatus: 'pending',
            approvalPrincipal: '',
            approvalLastReview: '',
            field1: '',
            field2: '',
            field3: '',
            email: 'test@test.com',
            entityType: data.entityDetails?.type,
          },
          linkData,
        }

        break
      case 'RETIREMENT':
        if (data.investingProfile?.retirementAccountType === 'TRUST_ACCOUNT') {
          finalEntityData = {
            entityData: {
              entityName: data.entityDetails?.name,
              entityType: 'Trust Account',
              ein: data.entityDetails?.ein,
              domicile: 'U.S. Citizen',
              primCountry: data.entityDetails?.addressInfo?.country,
              primAddress1: data.entityDetails?.addressInfo?.Street1,
              primAddress2: data.entityDetails?.addressInfo?.Street2 || '',
              primCity: data.entityDetails?.addressInfo?.city,
              primState: data.entityDetails?.addressInfo?.state,
              primZip: data.entityDetails?.addressInfo?.postalCode,
              emailAddress: data.entityDetails?.email,
              phone: parseInt(data.entityDetails?.phoneNumber || ''),
              ownersAI: data.investingProfile.accreditedInvestor === 'yes' ? 'Yes' : 'No',
              createdIpAddress: data.ipAddress,
              KYCstatus: 'Pending',
              AMLstatus: 'Pending',
              entityDesc: 'Trust Account',
              emailAddress2: data.entityDetails?.email,
              phone2: parseInt(data.entityDetails?.phoneNumber || ''),
              totalAssets: 0,
              AMLdate: '',
              tags: '',
              notes: '',
              formationDate: '',
            },
            partyData,
            accountData: {
              emailAddress: data.entityDetails?.email,
              accountRegistration: data.entityDetails?.companyName,
              type: 'Trust',
              domesticYN: 'domestic account',
              streetAddress1: data.entityDetails?.addressInfo?.Street1,
              streetAddress2: data.entityDetails?.addressInfo?.Street2 || '',
              city: data.entityDetails?.addressInfo?.city,
              state: data.entityDetails?.addressInfo?.state,
              zip: data.entityDetails?.addressInfo?.postalCode,
              country: 'USA',
              phone: parseInt(data.entityDetails?.phoneNumber || ''),
              taxID: '',
              KYCstatus: 'pending',
              AMLstatus: 'pending',
              suitabilityScore: '',
              suitabilityDate: '',
              suitabilityApprover: '',
              AccreditedStatus: 'pending',
              AIlow: 'income',
              AIdate: '',
              '506cLimit': '',
              accountTotalLimit: '',
              singleInvestmentLimit: '',
              associatedAC: 'yes',
              syndicate: 'no',
              tags: '',
              notes: '',
              approvalStatus: 'pending',
              approvalPrincipal: '',
              approvalLastReview: '',
              field1: '',
              field2: '',
              field3: '',
            },
            linkData,
          }
        } else {
          finalEntityData = {
            entityData: {
              entityName: data.entityDetails?.companyName,
              entityType: 'Retirement Account',
              ein: data.entityDetails?.ein,
              domicile: 'U.S. Citizen',
              primCountry: data.entityDetails?.addressInfo?.country,
              primAddress1: data.entityDetails?.addressInfo?.Street1,
              primAddress2: data.entityDetails?.addressInfo?.Street2 || '',
              primCity: data.entityDetails?.addressInfo?.city,
              primState: data.entityDetails?.addressInfo?.state,
              primZip: data.entityDetails?.addressInfo?.postalCode,
              emailAddress: data.entityDetails?.email,
              phone: parseInt(data.entityDetails?.phoneNumber || ''),
              ownersAI: data.investingProfile.accreditedInvestor === 'yes' ? 'Yes' : 'No',
              createdIpAddress: data.ipAddress,
              KYCstatus: 'Pending',
              AMLstatus: 'Pending',
              entityDesc: 'Retirement Account',
              emailAddress2: data.entityDetails?.email,
              phone2: parseInt(data.entityDetails?.phoneNumber || ''),
              totalAssets: 0,
              AMLdate: '',
              tags: '',
              notes: '',
              formationDate: '',
            },
            partyData,
            accountData: {
              emailAddress: data.entityDetails?.email,
              accountRegistration: data.entityDetails?.companyName,
              type: 'IRA',
              domesticYN: 'domestic account',
              streetAddress1: data.entityDetails?.addressInfo?.Street1,
              streetAddress2: data.entityDetails?.addressInfo?.Street2 || '',
              city: data.entityDetails?.addressInfo?.city,
              state: data.entityDetails?.addressInfo?.state,
              zip: data.entityDetails?.addressInfo?.postalCode,
              country: 'USA',
              phone: parseInt(data.entityDetails?.phoneNumber || ''),
              taxID: '',
              KYCstatus: 'pending',
              AMLstatus: 'pending',
              suitabilityScore: '',
              suitabilityDate: '',
              suitabilityApprover: '',
              AccreditedStatus: 'pending',
              AIlow: 'income',
              AIdate: '',
              '506cLimit': '',
              accountTotalLimit: '',
              singleInvestmentLimit: '',
              associatedAC: 'yes',
              syndicate: 'no',
              tags: '',
              notes: '',
              approvalStatus: 'pending',
              approvalPrincipal: '',
              approvalLastReview: '',
              field1: '',
              field2: '',
              field3: '',
            },
            linkData,
          }
        }

        break

      default:
        throw new Error(`Unsupported investment profile option: ${data.investingProfile?.option}`)
    }

    const request: AxiosRequestConfig = {
      method: 'post',
      url: `${RISE_UP_API_V1}/north-capital/onboard-entity`,
      data: finalEntityData,
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${bearer_token}`,
      },
    }

    let res: AxiosResponse
    res = await axios(request)
    return res
  }

  const addCard = async (accountId: string, tradeId: string, bearer_token: string) => {
    const request: AxiosRequestConfig = {
      method: 'post',
      url: `${RISE_UP_API_V1}/north-capital/add-card`,
      data: {
        accountId,
        tradeId,
      },
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${bearer_token}`,
      },
    }

    let res: AxiosResponse
    res = await axios(request)
    return res
  }

  const requestKycAml = async (partyId: string) => {
    const request: AxiosRequestConfig = {
      method: 'post',
      url: `${RISE_UP_API_V1}/north-capital/perform-kyc-aml/basic`,
      data: {
        partyId: partyId,
      },
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
      },
    }

    let res: AxiosResponse
    try {
      res = await axios(request)
      return res
    } catch (error) {
      consoleLog('request KycAml error', error)
      return error
    }
  }

  const createTrade = async (
    accountId: string,
    transactionType: string,
    transactionUnits: number,
    bearer_token: string,
  ) => {
    const createdIpAddress = await getIPAddress()
    const request: AxiosRequestConfig = {
      method: 'post',
      url: `${RISE_UP_API_V1}/north-capital/create-investment-trade`,
      data: {
        offeringId: String(OFFERING_ID),
        accountId,
        transactionType,
        transactionUnits,
        createdIpAddress,
      },
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${bearer_token}`,
      },
    }

    let res: AxiosResponse
    res = await axios(request)
    return res
  }

  const initiateCardPayment = async (accountId: string, tradeId: number, bearer_token: string) => {
    const createdIpAddress = await getIPAddress()
    const request: AxiosRequestConfig = {
      method: 'post',
      url: `${RISE_UP_API_V1}/north-capital/initiate-card-payment`,
      data: {
        accountId,
        tradeId,
        createdIpAddress,
      },
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${bearer_token}`,
      },
    }

    let res: AxiosResponse
    res = await axios(request)
    return res
  }

  const addExternalAccount = async (
    accountId: string,
    ExtAccountfullname: string,
    ExtBankname: string,
    ExtRoutingnumber: string,
    ExtAccountnumber: string,
    bearer_token: string,
  ) => {
    const request: AxiosRequestConfig = {
      method: 'post',
      url: `${RISE_UP_API_V1}/north-capital/add-external-account`,
      data: {
        types: 'Account',
        accountId,
        ExtAccountfullname,
        Extnickname: ExtAccountfullname,
        ExtBankname,
        ExtRoutingnumber,
        ExtAccountnumber,
        updatedIpAddress: '10.0.0.115',
      },
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${bearer_token}`,
      },
    }

    let res: AxiosResponse
    res = await axios(request)
    return res
  }

  const initiateACHPayment = async (
    accountId: string,
    tradeId: string,
    NickName: string,
    amount: number,
    checkNumber: string,
    description: string,
    bearer_token: string,
  ) => {
    const createdIpAddress = await getIPAddress()

    const request: AxiosRequestConfig = {
      method: 'post',
      url: `${RISE_UP_API_V1}/north-capital/initiate-ach-payment`,
      data: {
        accountId,
        offeringId: String(OFFERING_ID),
        tradeId,
        NickName,
        amount,
        checkNumber,
        description,
        createdIpAddress,
      },
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${bearer_token}`,
      },
    }

    let res: AxiosResponse
    res = await axios(request)
    return res
  }

  const linkExternalAccount = async (bearer_token: string) => {
    const request: AxiosRequestConfig = {
      method: 'post',
      url: `${RISE_UP_API_V1}/north-capital/link-external-account`,

      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${bearer_token}`,
      },
    }

    let res: AxiosResponse
    res = await axios(request)
    return res
  }

  const getLinkedCreditCard = async (bearer_token: string) => {
    const request: AxiosRequestConfig = {
      method: 'get',
      url: `${RISE_UP_API_V1}/north-capital/get-linked-card`,
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${bearer_token}`,
      },
    }

    let res: AxiosResponse
    res = await axios(request)
    return res
  }

  const getLinkedExternalAccount = async (bearer_token: string) => {
    const request: AxiosRequestConfig = {
      method: 'post',
      url: `${RISE_UP_API_V1}/north-capital/get-link-external-account`,
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${bearer_token}`,
      },
    }

    let res: AxiosResponse
    res = await axios(request)
    return res
  }

  const getNorthCapitalIds = async (bearer_token: string) => {
    const request: AxiosRequestConfig = {
      method: 'get',
      url: `${RISE_UP_API_V1}/north-capital/get-ids`,
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${bearer_token}`,
      },
    }

    let res: AxiosResponse
    res = await axios(request)
    return res
  }

  return {
    onboardIndividual,
    onboardJoint,
    requestKycAml,
    createTrade,
    addCard,
    initiateCardPayment,
    onboardEntity,
    addExternalAccount,
    initiateACHPayment,
    linkExternalAccount,
    getLinkedCreditCard,
    getLinkedExternalAccount,
    getNorthCapitalIds,
  }
}
